import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class PageService {
    constructor(private http: HttpClient, private translate: TranslateService, private toastr: ToastrService) { }
    public checkoutCartSubject$: BehaviorSubject<any[]> = new BehaviorSubject(null);
    readonly checkoutCart$: Observable<any[]> = this.checkoutCartSubject$.asObservable();
    getCheckoutPage(params) {
        return this.http.post<any>(`${environment.apiUrl}/page/checkout`, params).pipe(
            tap(result => {
                if (!_.isEmpty(result?.cart?.warnings)) this.displayWarnings(result.cart.warnings);
                this.checkoutCartSubject$.next(result.cart);
            })
        )
    }

    displayWarnings(warnings: { type: string, title: { en: string, ar: string }, description: { en: string, ar: string }}[]) {
        const localize = (val: { en: string, ar: string }) => (val?.[this.translate?.currentLang ?? 'en']);
        _.each(warnings, (warn) => {
            this.toastr.warning(localize(warn.description), localize(warn.title));
        });
    }
}
